import { NavigationProvider, useModal } from "@/contexts";
import { LOCAL_STORAGE, useSetBookingRecoilState, useSetToggleState } from "@/shared/client";
import { useGetBaseInfo, type BaseInfoResponse } from "@/shared/server";
import { insertGoogleAnalytics } from "@/utils";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./header";

export const Layout = () => {
    const { data } = useGetBaseInfo<BaseInfoResponse>();
    const { isPrivate, logoUrl, navigation, pensionInfo, ga, bookingUrl, ybs } = { ...data };
    const { pathname } = useLocation();
    const { closeModal } = useModal();
    const setToggleState = useSetToggleState();
    const setBookingEngineState = useSetBookingRecoilState();

    useEffect(() => {
        window.scrollTo(0, 0);
        setToggleState(false);
        closeModal();

        if (pensionInfo) {
            if (ga?.head) insertGoogleAnalytics(ga);
            LOCAL_STORAGE.set({ key: "pensionName", value: `${pensionInfo.name.kr}` });

            if (bookingUrl) {
                const isGoogleBE = bookingUrl.includes("booking-engine");
                setBookingEngineState({ isGoogleBE, bookingUrl });
            }
        }
    }, [pathname, ga]);

    const navigationData = {
        navigation: {
            roomList: data?.navigation.roomList || [],
            specialList: data?.navigation.specialList || [],
        },
    };

    return (
        <>
            <Helmet>
                <title>{pensionInfo?.name.kr}</title>
            </Helmet>
            <Header navigation={navigation} logoUrl={logoUrl} pensionInfo={pensionInfo} />
            <NavigationProvider value={navigationData}>
                <Outlet />
            </NavigationProvider>
            <Footer isPrivate={isPrivate} logoUrl={logoUrl} pensionInfo={pensionInfo} ybs={ybs} />
        </>
    );
};
